module.exports = __webpack_public_path__ + "img/switch.d3eb1dd2.png";